// Approximate to the closest prefixed unit
const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
export function convertSizeToReadableUnits(numberOfBytes): string {
  const exponent = Math.min(Math.floor(Math.log(numberOfBytes) / Math.log(1024)), BYTE_UNITS.length - 1);

  const approx = numberOfBytes / 1024 ** exponent;
  const output = exponent === 0 ? `${numberOfBytes}B` : `${approx.toFixed(0)} ${BYTE_UNITS[exponent]}`;
  return output;
}
